import { Controller } from "@hotwired/stimulus"
import consumer from "../channels/consumer"
import { get } from "@rails/request.js"
import pluralize from 'pluralize';

export default class extends Controller {

  static values = {
    channel: String,
    klass: String,
    userId: String,
  }

  connect() {
    if (this.existingSubscriptions().length === 0) {
      this.subscription = consumer.subscriptions.create(this.identifier(), {
        connected: () => {
          console.log(`Connected to ${this.channel()}`);
        },

        disconnected: () => {
          // console.log(`Disconnected from ${this.channel()}`);
        },

        received: (data) => {
          this.handleReceived(data);
        }
      });
    } else {
      this.subscription = existingSubscription;
    }
  }

  disconnect() {
    // console.log("Disconnecting...");
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // Pluralize klassValue and append 'Channel'
  channel() {
    if (this.hasChannelValue) {
      return this.channelValue;
    } else {
      return pluralize(this.klassValue) + "Channel";
    }
  }

  defaultEvent() {
    return this.klassValue.toLowerCase().replace(/::/g, "_") + "_created";
  }

  identifier() {
    return { channel: this.channel(), user_id: this.userIdValue };
  }

  jsonId() {
    return JSON.stringify(this.identifier());
  }

  existingSubscriptions() {
    return consumer.subscriptions.findAll(this.jsonId());
  }

  // Subclasses could define this to handle data received from the channel.
  handleReceived(data) {
    if (data.event === this.defaultEvent() && !document.getElementById(data.id)) {
      get(data.url, { responseKind: "turbo-stream" });
      history.pushState(null, "", data.url);
    }
  }
}
